export default "__VITE_ASSET__DVxU0kFW__"